import Vue from 'vue';
import Router from 'vue-router';
import vueMethodsPromise from 'vue-methods-promise';
import ProtectPage from '@/views/auth/protect_page';
import Login from '@/views/auth/login';
import Onboarding from '@/views/mobile/auth/onboarding';
import Activation from '@/views/mobile/auth/activation';
import Auth from '@/views/auth/authTab';
import ForgotPassword from '@/views/auth/forgot_password';
import ResetPassword from '@/views/auth/reset_password';
import Confirmation from '@/views/auth/confirmation';
import SocialVerification from '@/views/auth/social_verify';
import ChartPageIndex from "@/views/chartPage";
import TwitterConfirmPage from '@/views/auth/twitter_confirm';
import TwitterCallbackPage from '@/views/auth/twitter_callback';
import TermsPage from '@/views/terms/index';
import OverviewPage from '@/views/overview/index';
import AdminPage from '@/views/admin/admin';
import Home from '@/views/landingPages/landing1';
import welcomePage from '@/views/welcomePage/index.vue'
import supportPage from '@/views/supportPage/index.vue'
import Creators from '@/views/landingPages/landing2';
import AdFree from '@/views/landingPages/landing3';
import LoginPage from '@/views/LoginPage';
import SignUpPage from '@/views/SignUpPage';
import AddAttendee from '@/views/home/add_attendee';
import Playlist from '@/views/Playlists/playlist';
import ActivityIndex from '@/views/activity/index';
import NotificationIndex from '@/views/notification/index';
import CollectionIndex from '@/views/collection/index';
import Chat from '@/views/chat/chat';
import DirectMessages from '@/views/user/direct_messages';
import MembersPage from '@/views/user/members';
import Cart from '@/views/cart/cart';
import Checkout from '@/views/cart/checkout';
import Sell from '@/views/sell/sell';
import OrderDetail from '@/views/sell/orderdetail';
import AddProduct from '@/views/sell/add_product';
import EditProduct from '@/views/sell/edit_product';
import ProductIndex from '@/views/product/index';
import AlbumIndex from '@/views/album/index';
import PlaylistDetail from '@/views/album/playlist';
import ManageIndex from '@/views/manage';
import AlbumStats from '@/views/album/album_stats';
import AlbumsManage from '@/views/album/manage';
import LabelsManage from '@/views/label/manage';
import CreateLive from '@/views/video/live';
import SpotLight from '@/views/spotlight';
import UploadIndex from '@/views/upload';
import UploadAlbum from '@/views/album/upload_album';
import AlbumEdit from '@/views/album/album_edit';
import PaymentIndex from '@/views/payments/index';
import StripeConnectPage from '@/views/user/stripe_connect';
import UserProfile from '@/views/user/profile';
import NotFound from '@/views/404';
import UserGetVerified from '@/views/user/get_verified';
import UserSettings from '@/views/settings/index';
import TopCreators from '@/views/topCreators';
import VideoIndex from '@/views/video/index';
import VideoManage from '@/views/video/manage';
import VideoEdit from '@/views/video/edit';
import VideoShow from '@/views/video/show';
import VideoDelete from '@/views/video/delete';
import Partners from '@/views/partners/';
import Dashboard from '@/views/dashboard/';
import SubscribeIndex from '@/views/subscribe/';
import LandingNew from '@/views/landing-new/';
import ForCreators from '@/views/landing-new/components/ForCreators.vue';
import ConfirmPage from '@/views/mobile/auth/confirmation'
import QRPage from '@/views/mobile/QR'
import CommunityMobile from "@/views/new-mobile/community";
import CartMobile from "@/views/new-mobile/cart";
import CheckoutMobile from "@/views/new-mobile/checkout";
import ConfirmationMobile from "@/views/new-mobile/confirmation";
import YouMobile from "@/views/new-mobile/you";
import LibraryMobile from "@/views/new-mobile/library";
import NotificationMobile from "@/views/new-mobile/notification";
import MessagesMobile from "@/views/new-mobile/messages";
import SpotlightMobile from "@/views/new-mobile/spotlight";
import DiscoverMobile from "@/views/new-mobile/discover";
import PlayerMobile from "@/views/new-mobile/player";
import ProfileMobile from "@/views/new-mobile/profile";
import PlanMobile from "@/views/new-mobile/plan";
import PlanDetailMobile from "@/views/new-mobile/plan_detail";
import ChatRoomMobile from "@/views/new-mobile/chat_room";

import VideoInfo from '@/views/video/estimate'; // Ensure this path is correct
import VideoCreate from '@/views/video/create'; // Ensure this path is correct
import VideoUpload from '@/views/video/upload'; // Ensure this path is correct

let isMobile = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
};

const onMobile = isMobile();

const setComponent = (path, hasNoIndexFile) => {
  const ext = hasNoIndexFile ? '.vue' : 'index.vue';
  const addEndSlash = hasNoIndexFile ? '' : '/';

  if (onMobile) {
    return () => import(`@/views/mobile/${path}${addEndSlash}${ext}`);
  } else {
    return () => import(`@/views/${path}${addEndSlash}${ext}`);
  }
};

Vue.use(vueMethodsPromise);
Vue.use(Router);

export function createRouter(settings) {
  let routes = [
    { path: '/', name: 'Home', component: LandingNew, meta: { allowOnMobile: true, noSideSpace: true, bgDark: true } },
    { path: '/landing-x', name: 'LandingX', component: Home, meta: { allowOnMobile: true, noSideSpace: false } },
    { path: '/creators', name: 'Creators', component: Creators, meta: { allowOnMobile: true } },
    { path: '/adfree', name: 'AdFree', component: AdFree, meta: { allowOnMobile: true } },
    { path: "/chatroomm", name: "ChatRoomMobile", component: ChatRoomMobile, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true } },
    { path: "/communitym", name: "CommunityMobile", component: CommunityMobile, meta: { allowOnMobile: true, onlyOnMobile: true } },
    { path: "/username/m", name: "ProfileMobile", component: ProfileMobile, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true, bgBlack: true } },
    { path: "/username/plansm", name: "PlanMobile", component: PlanMobile, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true, bgBlack: true } },
    { path: "/username/plan-detailsm", name: "PlanDetailMobile", component: PlanDetailMobile, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true, bgBlack: true } },
    { path: "/playerm", name: "PlayerMobile", component: PlayerMobile, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true } },
    { path: "/discoverm", name: "DiscoverMobile", component: DiscoverMobile, meta: { allowOnMobile: true, onlyOnMobile: true } },
    { path: "/spotlightm", name: "SpotlightMobile", component: SpotlightMobile, meta: { allowOnMobile: true, onlyOnMobile: true } },
    { path: "/notificationsm", name: "NotificationMobile", component: NotificationMobile, meta: { allowOnMobile: true, onlyOnMobile: true } },
    { path: "/messagesm", name: "MessagesMobile", component: MessagesMobile, meta: { allowOnMobile: true, onlyOnMobile: true } },
    { path: "/youm", name: "YouMobile", component: YouMobile, meta: { allowOnMobile: true, bgBlack: true, onlyOnMobile: true } },
    { path: "/username/librarym", name: "LibraryMobile", component: LibraryMobile, meta: { allowOnMobile: true, bgBlack: true, onlyOnMobile: true } },
    { path: "/cartm", name: "CartMobile", component: CartMobile, meta: { allowOnMobile: true, onlyOnMobile: true } },
    { path: "/checkoutm", name: "CheckoutMobile", component: CheckoutMobile, meta: { allowOnMobile: true, onlyOnMobile: true } },
    { path: "/confirmationm", name: "ConfirmationMobile", component: ConfirmationMobile, meta: { allowOnMobile: true, onlyOnMobile: true } },
    { path: '/protect', name: 'ProtectPage', component: ProtectPage },
    { path: '/login-page', name: 'Login', component: Login, meta: { showGoBack: true } },
    { path: '/login', name: 'Login', component: LoginPage, meta: { allowOnMobile: true, noSideSpace: true, authPage: true, showGoBack: true, bgNaturalGrey: true } },
    { path: '/signup', name: 'SignUpPage', component: onMobile ? QRPage : SignUpPage, meta: { showGoBack: true, allowOnMobile: true, noSideSpace: true, bgNaturalGrey: true, QRPage: true } },
    { path: '/forgot', name: 'ForgotPassword', component: ForgotPassword, meta: { showGoBack: true } },
    { path: '/reset_password/:token', name: 'ResetPassword', component: ResetPassword, meta: { noSidebar: true, allowOnMobile: true } },
    { path: '/members/:slug', name: 'MembersPage', component: MembersPage, meta: { allowOnMobile: true } },
    { path: '/terms', name: 'TermsPage', component: TermsPage, meta: { allowOnMobile: true } },
    { path: '/squad', name: 'OverviewPage', component: OverviewPage },
    { path: '/chart', name: 'ChartPageIndex', component: ChartPageIndex },
    { path: '/_oauth/verification', name: 'SocialVerification', component: SocialVerification },
    { path: '/_oauth/stripe_connect_callback', name: 'StripeConnectPage', component: StripeConnectPage },
    { path: '/_oauth/twitter_confirm', name: 'TwitterConfirmPage', component: TwitterConfirmPage },
    { path: '/_oauth/twitter_callback', name: 'TwitterCallbackPage', component: TwitterCallbackPage },
    { path: '/confirm/:token', name: 'Confirmation', component: onMobile ? ConfirmPage : Confirmation, meta: { allowOnMobile: true } },
    { path: '/welcome', name: 'welcomePage', component: welcomePage, meta: { allowOnMobile: true, welcomePage: true } },
    { path: '/support', name: 'support', component: supportPage, meta: { allowOnMobile: true, noSidebar: true } },
  ];

  if (!settings.disable_sign_up) {
    routes = routes.concat([
      { path: '/onboarding', name: 'Onboarding', component: Onboarding },
      { path: '/activation', name: 'Activation', component: Activation, meta: { hideMobileHeader: true, noSideSpace: true } },
      { path: '/register', name: 'Register', component: Auth },
      { path: '/register/invited/:token', name: 'InvitedRegister', component: Auth },
    ]);
  } else {
    routes = routes.concat([
      { path: '/register', name: 'RegisterAs', redirect: '/login' },
      { path: '/register/listener', name: 'ListenerRegister', redirect: '/login' },
      { path: '/register/artist', name: 'ArtistRegister', redirect: '/login' },
      { path: '/register/label', name: 'LabelRegister', redirect: '/login' },
      { path: '/register/brand', name: 'BrandRegister', redirect: '/login' },
    ]);
  }

  routes = routes.concat([
    { path: '/admin', name: 'AdminPage', component: AdminPage, meta: { bgNaturalGrey: true, noPadding: true, noMargin: true } },
    { path: '/video', name: 'VideoIndex', component: VideoIndex, meta: { noSideSpace: onMobile, senderRoute: 'video', bgGrey: true } },
    { path: '/music/discover', name: 'AlbumIndex', component: AlbumIndex, meta: { showRightAltIcon: true, noSideSpace: true, senderRoute: 'video', bgGrey: true } },
    { path: '/product', name: 'ProductIndex', component: ProductIndex, meta: { senderRoute: 'merch', bgGrey: false, bgLight: true } },
    { path: '/search', name: 'Search', component: setComponent('search/search', true), props: (route) => ({ query: route.query.q }), meta: { isModalComp: !!onMobile } },
    { path: '/feed', name: 'Feed', component: setComponent('feed'), meta: { noSideSpace: onMobile, showRightAltIcon: onMobile } },
    { path: '/activity', name: 'ActivityIndex', component: ActivityIndex },
    { path: '/notifications', name: 'NotificationIndex', component: NotificationIndex, meta: { bgGrey: true, bgLight: false } },
    { path: '/collection', name: 'CollectionIndex', component: CollectionIndex, meta: { bgGrey: true } },
    { path: '/messages', name: 'Messages', component: setComponent('messages'), meta: { noSideSpace: onMobile, bgGrey: true, bgLight: false } },
    { path: '/cart', name: 'Cart', component: Cart, meta: { noPadding: true } },
    { path: '/cart/checkout', name: 'Checkout', component: Checkout },
    { path: '/sell', name: 'Sell', component: Sell, meta: { bgNaturalGrey: true } },
    { path: '/sell/order/:slug', name: 'OrderDetail', component: OrderDetail, meta: { noPadding: true } },
    { path: '/upload/product/add', name: 'AddProduct', component: AddProduct, meta: { bgNaturalGrey: true } },
    { path: '/product/edit/:id', name: 'EditProduct', component: EditProduct },
    { path: '/product/:id', name: 'SingleProduct', component: setComponent('sell/single_product', true), meta: { isModalComp: !!onMobile, noSideSpace: onMobile } },
    { path: '/album/:slug', name: 'AlbumDetail', component: setComponent('album/album', true), meta: { isModalComp: !!onMobile, showModalCompLeftIcon: true, noSideSpace: onMobile, bgLight: true } },
    { path: '/x', name: 'AddAttendee', component: AddAttendee },
    { path: '/playlist/:id', name: 'Playlist', component: Playlist },
    { path: '/playlist/:slug', name: 'PlaylistDetail', component: PlaylistDetail },
    { path: '/manage', name: 'ManageIndex', component: ManageIndex, meta: { bgNaturalGrey: true } },
    { path: '/album/:slug/stats', name: 'AlbumStats', component: AlbumStats },
    { path: '/albums', name: 'AlbumsManage', component: AlbumsManage },
    { path: '/labels', name: 'LabelsManage', component: LabelsManage },
    { path: '/live/', name: 'CreateLive', component: CreateLive },
    { path: '/spotlight', name: 'SpotLight', component: SpotLight },
    { path: '/upload/', name: 'UploadIndex', component: UploadIndex, meta: { wrapFullHeight: !!onMobile, bgNaturalGrey: true } },
    { path: '/upload/album', name: 'UploadAlbum', component: UploadAlbum, meta: { bgNaturalGrey: true } },
    { path: '/album/:slug/edit', name: 'AlbumEdit', component: AlbumEdit, meta: { bgNaturalGrey: true } },
    { path: '/verified', name: 'UserGetVerified', component: UserGetVerified },
    { path: '/payments', name: 'PaymentIndex', component: PaymentIndex, meta: { bgNaturalGrey: true } },
    { path: '/settings', name: 'UserSettings', component: UserSettings, meta: { bgNaturalGrey: true } },
    { path: '/top-creators', name: 'TopCreators', component: TopCreators },
    { path: '/partners', name: 'Partners', component: Partners },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: { bgNaturalGrey: true } },
    { path: '/subscribe', name: 'SubscribeIndex', component: SubscribeIndex },
    { path: '/user/:user/chat', name: 'Chat', component: Chat },
    { path: '/user/:user/messages', name: 'DirectMessages', component: DirectMessages },
    { path: '/for-creators', name: 'ForCreators', component: ForCreators, meta: { allowOnMobile: true, noSideSpace: true, bgDark: true } },
  ]);

  if (!settings.disable_live_video) {
    routes = routes.concat([
      { path: '/user/:user/video', name: 'VideoManage', component: VideoManage },
      { path: '/user/:user/video/info', name: 'VideoInfo', component: VideoInfo },
      { path: '/upload/create', name: 'VideoCreate', component: VideoCreate, meta: { bgNaturalGrey: true } },
      { path: '/upload/video', name: 'VideoUpload', component: VideoUpload, meta: { bgNaturalGrey: true } },
      { path: '/user/:user/video/edit', name: 'VideoEdit', component: VideoEdit },
      { path: '/user/:user/video/delete', name: 'VideoDelete', component: VideoDelete },
      { path: '/video/:videoId/edit', name: 'VideoUpload', component: VideoUpload, meta: { bgNaturalGrey: true } },
      { path: '/video/:videoId/show', name: 'VideoShow', component: VideoShow, meta: { bgGrey: true, isModalComp: !!onMobile, showModalCompLeftIcon: true, noSideSpace: onMobile } },
    ]);
  } else {
    routes = routes.concat([
      { path: '/user/:user/video', name: 'VideoManage', redirect: '/' },
      { path: '/user/:user/video/create', name: 'VideoCreate', redirect: '/' },
      { path: '/user/:user/video/delete', name: 'VideoDelete', redirect: '/' },
    ]);
  }

  routes = routes.concat([
    { path: '/:slug', name: 'UserProfile', component: UserProfile, meta: { bgLight: true } },
    { path: '*', name: 'NotFound', component: NotFound },
  ]);

  return new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        if (to.hash) {
          return { selector: to.hash, behavior: 'smooth' };
        } else {
          return { x: 0, y: 0 };
        }
      }
    },
    routes: routes,
  });
}



// WEBPACK FOOTER //
// ./src/router/index.js